import { Typography } from "@material-ui/core";
import {
  Box,
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  Paper,
  Radio,
  RadioGroup,
} from "@mui/material";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import { REACT_SAFETY_VIDEO_ACKNOWLEDGEMENT_SELF_REGISTRATION } from "../../actions/EndPoints";
import USA_visLogo from "../../assets/USA_Images/login_images/App-logo.svg";
import SubmitButtons from "../../components/DialogBoxComponent/SubmitButtons";
import Toast from "../../components/ToastContainer/CustomToast";
import httpCommon from "../../config/http-common";
import CommonUtil from "../../Util/CommonUtils";

function SelfRegistrationSuccess(props) {
  const location = useLocation();
  const dispatch = useDispatch();
  const history = useHistory();
  const { t } = useTranslation();
  const [visit, setVisit] = useState({});
  const [visitor, setVisitor] = useState({});
  const [checkListItems, setCheckListItems] = useState([]);
  const [ndaUrl, setNdaUrl] = useState(null);
  const [checkListAnswers, setCheckListAnswers] = useState(
    location.state.listValue,
  );
  const [code, setCode] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const selectLanguage = props.location.state.language;
  const videoAcknowledgement = props?.location?.state?.videoAcknowledgement;
  const companyId = props?.location?.state?.config;

  useEffect(() => {
    const unblock = history.block((location, action) => {
      if (action === "POP") {
        return false;
      }
      return true;
    });

    return () => {
      unblock();
    };
  }, []);

  useEffect(() => {
    setIsLoading(true);
    setCheckListItems(props.location.state.listValue);
    window.history.forward();

    const checkListQuestions = props.location.state.listValue.map((data) => ({
      Question: data.question,
      Answers: "",
    }));

    setCheckListAnswers(checkListQuestions);
    setIsLoading(false);
  }, []);

  const handleSubmit = () => {
    setIsLoading(true);
    var error = false;
    var isAnswersMatched = false;
    checkListItems.map((question) => {
      if (error) return;
      checkListAnswers.map((expertedAnswer) => {
        if (question.question === expertedAnswer.Question) {
          if (
            question.mandatory !== "No" &&
            CommonUtil.isEmpty(expertedAnswer.Answers)
          ) {
            Toast("Please answer mandatory questions", "error");
            error = true;
          }
        }
      });
    });

    if (error) {
      return;
    }

    checkListItems.map((question) => {
      if (isAnswersMatched) return;
      checkListAnswers.map((expertedAnswer) => {
        if (question.mandatory === "Yes") {
          if (question.question === expertedAnswer.Question) {
            if (
              question.expertedAnswer.toLowerCase() !==
              expertedAnswer.Answers.toLowerCase().trim()
            ) {
              Toast(
                selectLanguage
                  ? t("La lista de verificación no es la esperada")
                  : t("CHECK_LIST_MISMATCH"),
                "error",
              );
              handleCancel();
              isAnswersMatched = true;
            }
          }
        }
      });
    });
    if (isAnswersMatched) {
      return;
    }

    const payload = {
      visitId: props.location.state.id,
      answers: checkListAnswers,
    };

    httpCommon
      .unsecuredAxios()
      .post("/web/questionariesAnswer", payload)
      .then((res) => {
        const data = res.data;
        if (data.code === "CVHQI0000") {
          if (videoAcknowledgement) {
            history.push({
              pathname: REACT_SAFETY_VIDEO_ACKNOWLEDGEMENT_SELF_REGISTRATION,
              success: true,
              companyId: props?.location?.state?.config,
              dto: props?.location?.state?.dto,
            });
            return;
          } else {
            Toast(
              selectLanguage
                ? t("Autorregistro creado exitosamente")
                : t("SELF_REGISTRATION_CREATE"),
              "success",
            );
          }
          history.push({
            pathname: "/vis/visit-success",
            state: { message: res.data.message, success: true },
          });
          localStorage.clear();
        } else {
          Toast(data.message, "error");
        }
      })
      .catch((e) => {
        console.log(e);
      });
    setIsLoading(false);
  };

  const handleCancel = () => {
    const payload = {
      id: props.location.state.id,
    };
    const config = {
      headers: { companyId: companyId },
    };
    httpCommon
      .unsecuredAxios()
      .put("/web/visit/rejectByVisitId/" + payload.id, payload, config)
      .then((res) => {
        if (res.data.code === "CVAI0073") {
          localStorage.clear();
          history.push({
            pathname: "/vis/confirms-page/rejects",
            state: { message: res.data.message, cancel: true },
          });
        } else {
          Toast(res.data.message, "error");
          localStorage.clear();
        }
      })
      .catch((e) => {
        console.log(e);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const handleChange = (event) => {
    checkListAnswers.map((question) => {
      if (question.Question === event.target.name) {
        question.Answers = event.target.value;
      }
    });
  };

  return (
    <>
      <Grid
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "20px",
          backgroundColor: "#F4F6F8",
        }}
      >
        <Grid container alignItems="center">
          <Grid item className="logo-center">
            <img src={USA_visLogo} alt="logo" style={{ width: "180px" }} />
          </Grid>
        </Grid>
      </Grid>
      <Paper>
        <Typography
          gutterBottom
          variant="h3"
          style={{ padding: "25px", paddingLeft: "75px" }}
        >
          {selectLanguage
            ? t("Formulario de lista de verificación")
            : t("CHECK_LIST_HEADER")}
        </Typography>
        <Grid container p={5} spacing={3}>
          <Grid item xs={12} sm={12}>
            <Grid container direction="row">
              {checkListItems.length > 0 &&
                checkListItems.map((checkList, index) => {
                  return (
                    <Grid item xs={12} sm={6}>
                      <Box
                        display="flex"
                        p={2}
                        marginLeft={"20px"}
                        marginRight={"20px"}
                      >
                        {index + 1 + ". "}{" "}
                        <FormControl component="fieldset">
                          <FormLabel component="legend">
                            {checkList.question +
                              (checkList.mandatory !== "No" ? " *" : "")}
                          </FormLabel>
                          <RadioGroup
                            row
                            aria-label="gender"
                            name={checkList.question}
                            onChange={handleChange}
                          >
                            {checkList?.options.map((data) => {
                              const splittedData = data.split(",");
                              if (splittedData?.length >= 0) {
                                let options = [];
                                splittedData.map((option) =>
                                  options.push(
                                    <FormControlLabel
                                      value={option}
                                      control={<Radio />}
                                      label={option}
                                    />,
                                  ),
                                );
                                return options;
                              }
                            })}
                          </RadioGroup>
                        </FormControl>
                      </Box>
                    </Grid>
                  );
                })}
            </Grid>
          </Grid>
        </Grid>
        {/* {isLoading ? <Loader /> : */}
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
        >
          <Box display="flex" sx={{ m: 1 }}>
            <SubmitButtons
              sx={{ m: 1 }}
              onClick={handleSubmit}
              variant="contained"
            >
              <Typography>{t("CONTINUE_BUTTON")}</Typography>
            </SubmitButtons>
          </Box>
        </Grid>
        {/* } */}
      </Paper>
    </>
  );
}
export default SelfRegistrationSuccess;
